import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../defaultState';

const overlayScreenlice = createSlice({
    name: 'Config',
    initialState: initialState.overlay,
    reducers: {
        overlaySetVisible: (state, action) => {
            state.isVisible = true;
            state.screen = action.payload;
        },
        overlaySetInVisible: (state) => {
            state.isVisible = false;
            state.screen = '';
        },
    },
});

export const { overlaySetVisible, overlaySetInVisible } = overlayScreenlice.actions;

export default overlayScreenlice.reducer;
